const context = require.context(
  "../assets/images/home/halloween/2026",
  false,
  /\.(png|jpe?g|svg|webp)$/
);

export const halloweenAssets = {};

context.keys().forEach((key) => {
  const asset = context(key);
  halloweenAssets[key.replace("./", "")] = asset.default || asset;
});

const navigationFiles = {
  "promos-icon.webp": "promo.svg",
  "promos-icon-active.webp": "promo-active.svg",
  "sponsor-icon.webp": "sponsor.svg",
  "sponsor-icon-active.webp": "sponsor-active.svg",
  "home-icon.webp": "home.svg",
  "home-icon-active.webp": "home-active.svg",
  "live-icon.webp": "livechat.svg",
  "live-icon-active.webp": "livechat-active.svg",
  "me-icon.webp": "me.svg",
  "me-icon-active.webp": "me-active.svg",
};

export const halloweenNavigationAssets = {};

Object.entries(navigationFiles).forEach(([key, filename]) => {
  if (halloweenAssets[filename]) {
    halloweenNavigationAssets[key] = halloweenAssets[filename];
  }
});
